export enum UserDeliverySettingsAction {
  SetAddresses = 'setAddresses',
  SetIsPopupVisible = 'setIsPopupVisible',
  SetCurrentAddressTypeInPopup = 'setCurrentAddressTypeInPopup',
  SetInitialShippingValues = 'setInitialShippingValues',
  SetInitialBillingValues = 'setInitialBillingValues',
  SetAddressId = 'setAddressId',
  SetSmallDialogHeaderTranslation = 'setSmallDialogHeaderTranslation',
}
